import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { SubstanceParentCodeFields } from "../../../Data/Art57Data/SubstanceParentCodeFields";
import { CodeName } from "../../../../service/lookup-service/code-name.model";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceParentCodeFields extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new SubstanceParentCodeFields(new FieldDefinition(injector)),
        'Substance Parent EV Code'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Substance Parent EV Code';
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(lazy:boolean=true) {

      if (this.data && this.data.model &&
        this.data.model.referencetext &&
        this.data.model.referencetext.value) {
          if (this.data.model.referencetext.name) {
            this.label = this.data.model.referencetext.name;                
          
          } else if (!lazy) {
            this.ioc!.get(LookupGetService).getLookup('substanceparentcode',this.data.model.referencetext.value)
            .then((result: CodeName) => {
              if (result && result.name && result.name != '') {
                this.data.model.referencetext.name = result.name;
                this.refreshLabel();                
               } else {
                this.label = this.labelTemplate;
               }
            });
          }   
        } else {
          this.label = this.labelTemplate;
        } 

    }
  
    override getMessage(): any {
      if (this.data.model && Object.keys(this.data.model).length > 0) {
        return this.data.model;
      } else {
        return;
      }
    }

    override getListItem(): any[] {
      return [
        this.data.model && this.data.model.sourcecode && this.data.model.sourcecode.value
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'substancetype',
            this.data.model.sourcecode.value
          )
          : 'Not selected',
        this.data.model &&
          this.data.model.referencetext &&
          this.data.model.referencetext.value &&
              this.data.model.referencetext.name? 
                  this.data.model.referencetext.name
              : 'Not selected'
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeSubstanceParentCodeFields =
        new TreeNodeSubstanceParentCodeFields(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.refreshLabel();
  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];

      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
  }
  }